import { useSearch } from '../SpotlightState';
import { useSpotlightCapabilities } from './useSpotlightCapabilities';

export function useSelectRecentSearch() {
	const { setSearchTerm, defaultSearchAction } = useSearch();
	const { canShowStickySearch } = useSpotlightCapabilities();

	return (term: string) => {
		defaultSearchAction(term);

		if (canShowStickySearch) {
			setSearchTerm(term);
		}
	};
}
